import { createApp } from 'vue';
import OnlineBookingApp from './vue/OnlineBookingApp.vue';
import './_modules/booking-treatment-autocomplete.js';
import './_modules/booking-calendar.js';
import '@/less/_modules/inclusive-dates-theme.less';

if (document.getElementById('online-booking-app')) {
  createApp(OnlineBookingApp).mount('#online-booking-app');
}


// Add analytics stage tracking?